import { TextInput } from '@makemydeal/dr-shared-components/text-input';
import { Typography } from '@interstate/components/Typography';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { useCustomerCardContext } from '../CustomerFormContext';
import { FieldsRow, SummaryFieldsRow } from './sectionLayout.styles';

/**
 * Renders the Emails field group inside CustomerForm.
 * Reads all state and handlers from CustomerFormContext — accepts no props.
 *
 * Summary mode: email only (2-column grid, no section heading)
 * Full mode:    Emails heading + email, emailAlternative (2-column grid)
 *
 * Optional desking: email required field shows "(required)" in label instead of asterisk.
 */
const EmailFields = () => {
    const { formValues, formErrors, handleInputChange, isLocked, viewMode, customerRole, isOptionalDeskingActive } =
        useCustomerCardContext();

    const requiredLabel = (base: string) => (isOptionalDeskingActive ? `${base} (required)` : base);

    const Row = viewMode === 'full' ? FieldsRow : SummaryFieldsRow;

    return (
        <>
            {viewMode === 'full' && (
                <Typography variant="h5" sx={{ marginBottom: '1rem', marginTop: '1.5rem' }}>
                    Emails
                </Typography>
            )}
            <Row>
                <TextInput
                    label={requiredLabel('Primary Email Address')}
                    name="email"
                    data-testid={`customer-form-${customerRole}-primary-email`}
                    className="pii"
                    value={formValues.email ?? ''}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                    disabled={isLocked}
                    hasError={formErrors?.email?.hasError}
                    errorMessage={formErrors?.email?.errorMessage}
                    selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
                    required={!isOptionalDeskingActive}
                    displayLabel
                    size="small"
                />
                {viewMode === 'full' && (
                    <TextInput
                        label="Secondary Email Address"
                        name="emailAlternative"
                        data-testid={`customer-form-${customerRole}-alternate-email`}
                        className="pii"
                        value={formValues.emailAlternative ?? ''}
                        onChange={(e) => handleInputChange('emailAlternative', e.target.value)}
                        disabled={isLocked}
                        hasError={formErrors?.emailAlternative?.hasError}
                        errorMessage={formErrors?.emailAlternative?.errorMessage}
                        selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
                        displayLabel
                        size="small"
                    />
                )}
            </Row>
        </>
    );
};

EmailFields.displayName = 'EmailFields';
export default EmailFields;
